import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "text-xs border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "text-xs border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "text-xs border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-xs text-foreground",
        "outline-sm": "text-sm text-foreground",
        success: "text-xs border-transparent bg-green-100 text-green-800",
        warning: "text-xs border-transparent bg-amber-100 text-amber-800",
        info: "text-xs border-transparent bg-blue-100 text-blue-800"
      }
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
